import { Directive, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

import { DragDropConfig } from '../config/drag-drop-config';
import { DragDropData } from '../models/drag-drop-data.model';
import { DragDropService } from '../service/drag-drop/drag-drop.service';

/* tslint:disable directive-selector no-output-on-prefix */
@Directive({ standalone: false, selector: '[dnd-free-draggable]' })
export class FreeDraggableDirective implements OnInit, OnDestroy {
  elementReference = inject(ElementRef);
  private dragDropService = inject(DragDropService);
  private config = inject(DragDropConfig);

  @Input()
  dragData: any;

  element: HTMLElement;
  defaultCursor: string;

  private _dragEnabled = true;
  get dragEnabled(): boolean {
    return this._dragEnabled;
  }

  @Input()
  set dragEnabled(value: boolean) {
    this._dragEnabled = value;
    this.element.draggable = value;
  }

  @Output()
  onDragStart: EventEmitter<DragDropData> = new EventEmitter();
  @Output()
  onDragEnd: EventEmitter<DragDropData> = new EventEmitter<DragDropData>();
  @Output()
  onDragSuccess: EventEmitter<any> = new EventEmitter<any>();

  private dataSubs = new Subscription();

  constructor() {
    this.element = this.elementReference.nativeElement;
    this.defaultCursor = this.element.style.cursor;
  }

  ngOnInit() {
    this.dataSubs.add(
      fromEvent(this.element, 'dragstart').subscribe((event: DragEvent) => {
        event.dataTransfer.setData('text', (<any>event.target).id);
        this.dragStartCallback(event);
      }),
    );

    this.dataSubs.add(
      fromEvent(this.element, 'dragend').subscribe((event: DragEvent) => {
        this.dragEndCallback(event);
      }),
    );
  }

  dragStartCallback(event: DragEvent): void {
    this.dragDropService.isDragged = true;
    this.dragDropService.dragData = this.dragData;
    this.dragDropService.onDragSuccessCallback = this.onDragSuccess;
    this.element.classList.add(this.config.onDragStartClass);
    this.onDragStart.emit({ dragData: this.dragData, mouseEvent: event });
  }

  dragEndCallback(event: DragEvent): void {
    this.dragDropService.isDragged = false;
    this.dragDropService.dragData = null;
    this.dragDropService.onDragSuccessCallback = null;
    this.element.classList.remove(this.config.onDragStartClass);
    this.onDragEnd.emit({ dragData: this.dragData, mouseEvent: event });
  }

  ngOnDestroy() {
    this.dataSubs.unsubscribe();
  }
}
